import __base_store from '@/store/__base_store'

/**
 * Store de rangos por categoría para tipos de precio (modelo `category_price_type_range`).
 * Construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'category_price_type_range',
	},
})

